import { useAuth } from '@/shared/hooks/useAuth';

const MANAGE_ROLES = new Set(['manager', 'admin', 'owner', 'agency_admin']);

/** Mirrors the backend's `authorize('manager', 'admin', 'owner')` on the calls
 *  management routes (agents, numbers, sources, closures), so viewers don't see
 *  controls that would only 403. Working the callback queue is open to everyone. */
export function useCanManageCalls(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.isAgency || MANAGE_ROLES.has(user.role ?? '');
}
